"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAlchemyUrl = void 0;
const misc_1 = require("@moojo/misc");
// currently supporting arbitrum networks only.
const makeAlchemyUrl = (network, key) => {
    if (network === 'mainnet') {
        return `https://arb-mainnet.g.alchemy.com/v2/${key}`;
    }
    if (network === 'testnet') {
        return `https://arb-sepolia.g.alchemy.com/v2/${key}`;
    }
    if (network === 'devnet') {
        return `https://arb-sepolia.g.alchemy.com/v2/${key}`;
    }
    (0, misc_1.shouldNeverHappen)(network);
};
exports.makeAlchemyUrl = makeAlchemyUrl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1hbGNoZW15LXVybC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zY2hlbWEvbWFrZS1hbGNoZW15LXVybC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBK0M7QUFJL0MsK0NBQStDO0FBQ3hDLE1BQU0sY0FBYyxHQUFHLENBQUMsT0FBZ0IsRUFBRSxHQUFXLEVBQUUsRUFBRTtJQUM5RCxJQUFJLE9BQU8sS0FBSyxTQUFTLEVBQUUsQ0FBQztRQUMxQixPQUFPLHdDQUF3QyxHQUFHLEVBQUUsQ0FBQTtJQUN0RCxDQUFDO0lBRUQsSUFBSSxPQUFPLEtBQUssU0FBUyxFQUFFLENBQUM7UUFDMUIsT0FBTyx3Q0FBd0MsR0FBRyxFQUFFLENBQUE7SUFDdEQsQ0FBQztJQUVELElBQUksT0FBTyxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQ3pCLE9BQU8sd0NBQXdDLEdBQUcsRUFBRSxDQUFBO0lBQ3RELENBQUM7SUFFRCxJQUFBLHdCQUFpQixFQUFDLE9BQU8sQ0FBQyxDQUFBO0FBQzVCLENBQUMsQ0FBQTtBQWRZLFFBQUEsY0FBYyxrQkFjMUIifQ==